import { action } from 'typesafe-actions'
import { ActionTypes } from './constants'
import type {
  EditProjectState,
  areaPointProperties,
  areaType,
  commentType,
  countType,
  editProperties,
  linearLineType,
  measureLineType,
  polygonType,
  scaleProperties,
} from './types'
export const batchDeleteShapes = (payload: {
  polygons?: EditProjectState['polygons']
  linearLines?: EditProjectState['linearLines']
  counts?: EditProjectState['counts']
  measure?: EditProjectState['measure']
}) => ({
  type: ActionTypes.BATCH_DELETE_SHAPES,
  payload,
})
export const setPageScale = (pageScale: editProperties['scale']) => {
  return action(ActionTypes.SET_SCALE, {
    pageScale,
  })
}
export const updateFreeHandShapes = (freeHandShapes: editProperties['freeHandShapes']) => {
  return action(ActionTypes.UPDATE_FREE_HAND_SHAPES, {
    freeHandShapes,
  })
}
export const updatePenShapes = (penShapes: editProperties['penShapes']) => {
  return action(ActionTypes.UPDATE_PEN_SHAPES, {
    penShapes,
  })
}
export const updateCloudShapes = (cloudShapes: editProperties['cloudShapes']) => {
  return action(ActionTypes.UPDATE_CLOUD_SHAPES, {
    cloudShapes,
  })
}
export const updateTextShapes = (textShapes: editProperties['textShapes']) => {
  return action(ActionTypes.UPDATE_TEXT_SHAPES, {
    textShapes,
  })
}

export const updateComments = (comments: editProperties['comments']) => {
  return action(ActionTypes.UPDATE_COMMENTS, {
    comments,
  })
}

export const undo = () => {
  return action(ActionTypes.UNDO, {})
}

export const updateCounts = (counts: countType[]) => {
  return action(ActionTypes.UPDATE_COUNTS, {
    counts,
  })
}

export const addMeasureLine = (measureLine: measureLineType) => {
  return action(ActionTypes.ADD_MEASURE_LINE, {
    measureLine,
  })
}

export const setUp = () => {
  return action(ActionTypes.SET_UP)
}

export const updateLinearLines = (linearLines: linearLineType[]) => {
  return action(ActionTypes.UPDATE_LINEAR_LINES, {
    linearLines,
  })
}
export const updatePolygons = (polygons: polygonType[]) => {
  return action(ActionTypes.UPDATE_POLYGONS, {
    polygons,
  })
}

export const clearCurrentPoints = () => {
  return action(ActionTypes.CLEAR_CURRENT_POINTS)
}

// Seeds a saved shape's vertices (Continue drawing). Left out of undo history so Undo can't peel them off.
export const setCurrentPoints = (points: areaPointProperties[]) => {
  return action(ActionTypes.SET_CURRENT_POINTS, {
    points,
  })
}

export const removeLastCurrentPoint = () => {
  return action(ActionTypes.REMOVE_LAST_CURRENT_POINT)
}

export const addToCurrentPoints = (point: areaPointProperties) => {
  return action(ActionTypes.ADD_TO_CURRENT_POINTS, {
    point,
  })
}

export const changeMeasureLine = (measureLine: measureLineType) => {
  return action(ActionTypes.CHANGE_MEASURE_LINE, {
    measureLine,
  })
}

export const removeMeasureLine = (id: string) => {
  return action(ActionTypes.REMOVE_MEASURE_LINE, {
    id,
  })
}
//new function for updating edit
export const updateProject = (
  linearLines: linearLineType[],
  polygons?: polygonType[],
  counts?: countType[],
  comments?: commentType[],
  scale?: scaleProperties,
) => {
  return action(ActionTypes.PROJECT_UPDATED, {
    linearLines,
    polygons,
    counts,
    comments,
    scale,
  })
}

export const updateMeasures = (measures?: measureLineType[], areas?: areaType[]) => {
  return action(ActionTypes.UPDATE_MEASURES, {
    measures,
    areas,
  })
}

export const setCurrentEdit = (currentEdit: EditProjectState) => {
  return action(ActionTypes.SET_CURRENT_EDIT, {
    currentEdit,
  })
}

export const setEditedPage = () => {
  return action(ActionTypes.SET_EDITED_PAGE, {})
}

export const cleanHistory = () => {
  return action(ActionTypes.CLEAN_HISTORY)
}
